import {AbstractControl, ValidatorFn} from '@angular/forms';

import {EmailValidatorKey} from './core-validator-keys';

export function EmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value && control.value.toString().trim();

        if (!controlValue) {
            return null;
        }

        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!regex.test(controlValue)) {
            return { [EmailValidatorKey]: true };
        }

        return null;
    };
}
